<template>
  <div class="icon-wrap">
    <svg class="icon" aria-hidden="true">
      <use :xlink:href="'#' + name"></use>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
  },
  watch: {
  },
  created() {
    // do something
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.icon-wrap {
  display: inline-flex;
  align-items: center;
}
.icon {
  width: 1em;
  height: 1em;
  fill: currentColor;
  overflow: hidden;
}
</style>
